import { exportWorkcenters, getWorkcenters } from '@/apis/workcenterAPI'

import { IWorkcenter } from '@/utils/types/model/workcenter'
import { CLEAR_WORKCENTERS, EXPORT_WORKCENTERS, FETCH_WORKCENTERS, SET_WORKCENTER_LOADING } from './actions'

type TWorkcenterState = {
  workcenters: IWorkcenter[]
  totalRecords: number
  isLoaded: boolean
  isLoading: boolean
}

export default {
  state: {
    workcenters: [],
    totalRecords: 0,
    isLoaded: false,
    isLoading: false,
  },
  mutations: {
    [FETCH_WORKCENTERS]: (
      state: TWorkcenterState,
      payload: {
        workcenters: IWorkcenter[]
        totalRecords: number
      }
    ) => {
      state.workcenters = payload.workcenters
      state.totalRecords = payload.totalRecords
      state.isLoaded = true
      state.isLoading = false
    },
    [CLEAR_WORKCENTERS]: (state: TWorkcenterState) => {
      state.workcenters = []
      state.totalRecords = 0
      state.isLoaded = false
      state.isLoading = false
    },
    [SET_WORKCENTER_LOADING]: (state: TWorkcenterState, loading: boolean) => {
      state.isLoading = loading
    },
  },
  actions: {
    [FETCH_WORKCENTERS]: async (
      { commit }: { commit: Function },
      payload: {
        page?: number
        limit?: number
        code?: string
        sortBy?: string
        sortType?: string
      } = {}
    ) => {
      try {
        commit(SET_WORKCENTER_LOADING, true)
        const { page = 1, limit = 10, code = '', sortBy, sortType } = payload
        const response = await getWorkcenters(page, limit, code, sortBy, sortType)
        if (!response) {
          throw new Error('No response from API')
        }
        commit(FETCH_WORKCENTERS, {
          workcenters: response.workcenterMasters || [],
          totalRecords: response.totalRecords || 0,
        })
        return response
      } catch (err) {
        commit(SET_WORKCENTER_LOADING, false)
        throw err
      }
    },
    [EXPORT_WORKCENTERS]: async (
      { commit }: { commit: Function },
      payload: {
        sortBy?: string
        sortType?: string
      } = {}
    ) => {
      try {
        commit(SET_WORKCENTER_LOADING, true)
        const data = {
          ...(payload.sortBy && { sortBy: payload.sortBy }),
          ...(payload.sortType && { sortType: payload.sortType }),
        }
        const response = await exportWorkcenters(data)
        commit(SET_WORKCENTER_LOADING, false)
        return response
      } catch (err) {
        commit(SET_WORKCENTER_LOADING, false)
        throw err
      }
    },
    [CLEAR_WORKCENTERS]: ({ commit }: { commit: Function }) => {
      commit(CLEAR_WORKCENTERS)
    },
  },
  getters: {
    getWorkcenters: (state: TWorkcenterState) => state.workcenters,
    getWorkcenterTotalRecords: (state: TWorkcenterState) => state.totalRecords,
    isWorkcenterLoading: (state: TWorkcenterState) => state.isLoading,
    isWorkcenterLoaded: (state: TWorkcenterState) => state.isLoaded,
  },
}
